import styled from "styled-components";

export const GameJackpotBarAmountDefaultBox = styled.span<{isOptInStatus?: boolean}>`
    font-size: 1.4rem;
    @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
        font-size: 1.6rem;
    }
    ${({theme}) => theme.font.presets.bold};
    line-height: 16.8px;
    transition: opacity 0.25s ease-in, transform 0.25s ease-in;
`;